import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../../slice/user/userSlice";
import exploreReducer from "../../slice/explore/exploreSlice";
import cartReducer from "../../slice/cart/cartSlice";
import favouriteReducer from "../../slice/favourite/favouriteSlice";
import sellerReducer from "../../slice/sellers/sellersSlice";
import profileReducer from "../../slice/profile/profileSlice";
import sellerhubReducer from "../../slice/sellerHub/sellerhubSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
  reducer: {
    user: persistedReducer,
    seller: sellerReducer,
    explore: exploreReducer,
    cart: cartReducer,
    favourite: favouriteReducer,
    profile: profileReducer,
    sellerhub: sellerhubReducer,
  },
  middleware: [thunk],
});

export const persistor = persistStore(store);
